import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';

// Admin console layout — no realtime WebSocket, no per-agent selection.
// verso_admin operates on the platform tier; org-scoped real-time lives on
// the org dashboard.

export default function AppShell() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
        <footer className="flex items-center justify-between border-t border-gray-200 bg-white px-6 py-2 text-xs text-gray-400">
          <span>Verso Admin Console &copy; {new Date().getFullYear()} Colorado Communications</span>
        </footer>
      </div>
    </div>
  );
}
